import React from 'react';

export const pageMeta = {
  "name": "JS Date Set",
  "link": "/javascript/dates/set"
};

export default function JavascriptDatesSet() {
  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h2 className="text-2xl font-semibold mb-2">JS Date Set</h2>
      <p>Route: /javascript/dates/set</p>
      <h3 className="mt-4 font-medium">sub_content</h3>
      <pre>{JSON.stringify(pageMeta, null, 2)}</pre>
    </div>
  );
}
